import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cn from 'classnames';

import smsLogo from '../../../static/images/logos/logo.png';

import './ShopPageHeaderImage.scss';

import SmartImage from '../../General/SmartImage';

const ShopPageHeaderImage = props => {
  const { activeRefinementObjects, isLoading } = props;
  const { activeCurator, activeCuratorGroup, activeCategory, activeDepartment, activeIndustry, activeBrands } = activeRefinementObjects;

  let data_to_cycle = []; // { image, name }

  if (activeCurator) {
    data_to_cycle = activeCurator.image ? [activeCurator] : [{ image: smsLogo, name: activeCurator.name }];
  } else if (activeCuratorGroup) {
    data_to_cycle = activeCuratorGroup.users
      ? activeCuratorGroup.users.filter(u => u.image).slice(0, 5)
      : [{ image: smsLogo, name: activeCuratorGroup.title }];
  } else if (activeCategory) {
    data_to_cycle = [
      {
        image: activeCategory.coverImage || activeCategory.exampleProductImage || smsLogo,
        name: activeCategory.name,
        additionalImgClass: !activeCategory.coverImage && activeCategory.exampleProductImage ? 'inset-image' : ''
      }
    ];
  } else if (activeDepartment) {
    data_to_cycle = [
      {
        image: activeDepartment.coverImage || activeDepartment.exampleProductImage || smsLogo,
        name: activeDepartment.name,
        additionalImgClass: !activeDepartment.coverImage && activeDepartment.exampleProductImage ? 'inset-image' : ''
      }
    ];
  } else if (activeIndustry) {
    data_to_cycle = [
      {
        image: activeIndustry.coverImage || activeIndustry.exampleProductImage || smsLogo,
        name: activeIndustry.name,
        additionalImgClass: !activeIndustry.coverImage && activeIndustry.exampleProductImage ? 'inset-image' : ''
      }
    ];
  } else if (activeBrands) {
    data_to_cycle = activeBrands[0].logo
      ? activeBrands.map(b => ({ image: b.logo, name: b.name, additionalImgClass: 'inset-image contain' }))
      : [{ image: smsLogo, name: 'Shop' }];
  } else {
    data_to_cycle = [{ image: smsLogo, name: 'Shop' }];
  }

  // Allow clicking the image to rotate to the next image without waiting
  const IMAGE_ROTATE_INTERVAL = 4000;
  const rotateRef = React.useRef(null);
  const [activeDataIdx, setActiveDataIdx] = React.useState(0);
  const nextImage = () => {
    setActiveDataIdx((activeDataIdx + 1) % data_to_cycle.length);
    clearTimeout(rotateRef.current);
    rotateRef.current = setTimeout(() => setActiveDataIdx((activeDataIdx + 1) % data_to_cycle.length), IMAGE_ROTATE_INTERVAL);
  };
  React.useEffect(() => {
    if (!isLoading) {
      rotateRef.current = setTimeout(() => setActiveDataIdx((activeDataIdx + 1) % data_to_cycle.length), IMAGE_ROTATE_INTERVAL);
      return () => clearTimeout(rotateRef.current);
    }
  }, [isLoading, activeDataIdx]);

  return (
    <div className='shop-page-header-image'>
      {isLoading ? (
        <div className='loading' />
      ) : (
        <div className='image-container-outer'>
          {data_to_cycle.map((data, idx) => (
            <div
              key={idx}
              className={cn('image-container', data.additionalImgClass || '', { active: idx === activeDataIdx || data_to_cycle.length === 1 })}
            >
              <SmartImage onClick={nextImage} src={data.image} alt={data.name} lazy={idx > 0} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

ShopPageHeaderImage.propTypes = {
  activeRefinementObjects: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default ShopPageHeaderImage;
